// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__30l5X","noInteraction":"EventWrapper_noInteraction__19hEs"};